import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { SideDetailViewService } from '@y42/core/container-with-side-detail-view';
import { delay } from 'rxjs';
import { DataTestBuilderSaveOutput, DataTestBuilderSidebarInput } from '../data-test-builder/data-test-builder.model';
import { SIDENAV_CONTENT_RENDER_DELAY_MS } from '../model';

@UntilDestroy()
@Component({
  selector: 'y42-data-test-builder-container',
  templateUrl: './data-test-builder-container.component.html',
  styleUrls: ['./data-test-builder-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTestBuilderContainerComponent {
  constructor(
    private readonly sideDetailViewService: SideDetailViewService<
      DataTestBuilderSaveOutput,
      DataTestBuilderSidebarInput
    >,
  ) {}

  readonly state = connectState(this, {
    sidebarOpened: this.sideDetailViewService.sidenavOpened$.pipe(delay(SIDENAV_CONTENT_RENDER_DELAY_MS)),
  });
}
